export const isObjectEquals = (a, b) => JSON.stringify(a) === JSON.stringify(b);
export const cloneObject = (object) => JSON.parse(JSON.stringify(object));
export const hasProperty = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
